import { AppTooltip } from './menu/AppTooltip';
import React from 'react';
import TipIcon from 'assets/icons/tip-icon.svg?react';
import styles from './Tip.module.scss';
import clsx from 'clsx';
import { PopperPlacementType } from '@mui/base/Popper/Popper.types';

type OwnProps = {
  className?: string;
  tooltipClassName?: string;
  tooltipText?: string;
  tooltipBody?: React.JSX.Element;
  customImage?: string;
  defaultIconClassname?: string;
  textBody?: React.JSX.Element;
  testId?: string;
  onClick?: () => void;
  customImageClassname?: string;
  placement?: PopperPlacementType;
} & Omit<React.ComponentProps<typeof AppTooltip>, 'children' | 'title'>;

export const Tip = (props: OwnProps) => {
  const {
    children,
    arrow,
    title,
    tooltipText,
    tooltipBody,
    tooltipClassName,
    customImage,
    className,
    defaultIconClassname,
    testId,
    textBody,
    onClick,
    customImageClassname,
    ...rest
  } = props;

  const tooltip = tooltipBody ? (
    tooltipBody
  ) : tooltipText ? (
    <div data-test-id={'status-tooltip-text'}>{tooltipText}</div>
  ) : null;

  return (
    <div data-test-id={testId}>
      <AppTooltip
        title={tooltip}
        placement={'top'}
        arrow={false}
        delay={0}
        className={clsx(styles.popper, tooltipClassName)}
        {...rest}
      >
        <div
          className={clsx(
            styles.tip,
            !customImage && !textBody && styles.hoveredTip,
            className,
          )}
        >
          {textBody ? (
            textBody
          ) : customImage ? (
            <img
              onClick={onClick}
              src={customImage}
              className={customImageClassname}
            />
          ) : (
            <TipIcon className={defaultIconClassname} />
          )}
        </div>
      </AppTooltip>
    </div>
  );
};
